import CityPageTemplate from "../city-template/CityPageTemplate";
import { castlePinesConfig } from "./data";

export default function CastlePinesPage() {
  return <CityPageTemplate config={castlePinesConfig} />;
}